import React, { useEffect, useContext, useRef, useState } from 'react'
import lottie from 'lottie-web'
import { ContextLoader } from '../context'
import loadFonts from '../helpers/loadFonts'
import loaderAnimData from "../images/lottie/loader.json"

const Loader = () => {

	const [isLoading, setIsLoading] = useContext(ContextLoader)
	const [isLoaderEnding, setIsLoaderEnding] = useState(false)
	const [areAssetsLoaded, setAreAssetsLoaded] = useState(false)
	const [isMinLoadingTimeEnded, setIsMinLoadingTimeEnded] = useState(false)

	const MIN_LOADING_TIME = 2000
	const LOADER_END_ANIM_TIME = 450

	// Handle loader ended
	useEffect(() => {
		if (areAssetsLoaded === true && isMinLoadingTimeEnded === true) {
			setIsLoaderEnding(true)
			setTimeout(() => {
				setIsLoading(false)
			}, LOADER_END_ANIM_TIME)
		}
	}, [areAssetsLoaded, isMinLoadingTimeEnded])

	// Launch assets loading
	useEffect(() => {
		handleFontsLoad().then(() => {
			setAreAssetsLoaded(true)
		})
	}, [setIsLoading])

	// Make sure the loader stay at least for showing basic intro
	useEffect(() => {
		setTimeout(() => {
			setIsMinLoadingTimeEnded(true)
		}, MIN_LOADING_TIME)
	}, [])

	// Lottie animation
	const animContainerEl = useRef(null)
	const lottieAnim = useRef(null)

	useEffect(() => {
		lottieAnim.current = lottie.loadAnimation({
			container: animContainerEl.current,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: loaderAnimData
		})
		return function clear () {
			lottieAnim.current.destroy();
		}
	}, [])


	// Load fonts
	const handleFontsLoad = () => {
		return new Promise(
			(resolve) => {
				loadFonts().then(() => {
					resolve()
				})
			}
		)
	}

	return (
		<div className={`Loader ${isLoaderEnding === true ? 'isEnding' : ''} ${isLoading === false ? 'isEnded' : ''}`}>
			<div className="Loader__Side Loader__Left"></div>
			<div className="Loader__Side Loader__Right"></div>
			<div className="Loader__Side Loader__Top"></div>
			<div className="Loader__Side Loader__Bottom"></div>
			<div className="Loader__Animation" ref={animContainerEl}></div>
			<div className="Loader__Progress"></div>
		</div>
	)
}

export default Loader